/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLoginRequest
 */
export interface ControlLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlLoginRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginRequest
     */
    origin?: string;
}

/**
 * Check if a given object implements the ControlLoginRequest interface.
 */
export function instanceOfControlLoginRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function ControlLoginRequestFromJSON(json: any): ControlLoginRequest {
    return ControlLoginRequestFromJSONTyped(json, false);
}

export function ControlLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
    };
}

export function ControlLoginRequestToJSON(value?: ControlLoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'origin': value.origin,
    };
}

